module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-15000-eaadf6b1.png";